import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';


@Injectable()
export class AlertaService {

  constructor() { }

  addAlert(type:string,msg:string,title?:string,timer?:number){

      let object: any={
          text:msg,
          title:title,
          showConfirmButton:false,
          timer:1000
      };
      if(timer && timer > 0){
          object['timer'] = timer;
      }

      if(timer && timer < 0){
          delete object['timer'];
      }

      switch (type){
          case 'success':
              object.type=type;
              break;
          case 'error':
              object.type=type;
              break;
          case 'warning':
              object.type=type;
              break;
          case 'confirm':
              object.title= (title)?title:'Are you sure?';
              object.type= 'warning';
              delete object.timer;
              object.showCancelButton= true;
              object.showConfirmButton=true;
              object.confirmButtonColor='#3085d6';
              object.cancelButtonColor= '#d33';
              object.confirmButtonText= 'Yes, I know!';
              object.cancelButtonText='No, cancel!';
              object.confirmButtonClass='btn btn-success';
              object.cancelButtonClass='btn btn-danger';
              object.buttonsStyling=true;
              object.reverseButtons=true;
              break;
          default:
              object.type='warning';
              object.text='SweetAlertType not exists!!'
              object.showCloseButton=true;
              delete  object.timer;
              }

      return Swal(object)
  }

    /*

    ejemplo warning con swal:

    Swal({
             title: 'Are you sure?',
             text: "Do you want to Delete provider "+ provider.name+ '?',
             type: 'warning',
             showCancelButton: true,
             confirmButtonColor: '#3085d6',
             cancelButtonColor: '#d33',
             confirmButtonText: 'Yes, delete it!',
             cancelButtonText: 'No, cancel!',
             confirmButtonClass: 'btn btn-success',
             cancelButtonClass: 'btn btn-danger',
             buttonsStyling: true,
             reverseButtons: true
         }).then((result) => {
             if (result.value) {
                 this.ProviderService.removeServiceProvider(provider.pk)
                     .subscribe( result => {
                     }, error => {
                         console.log(error);
                         Swal({
                             type: 'warning',
                             text: 'Something Went Wrong'
                         });
                     }, () => {
                         Swal({
                             type: 'success',
                             text: 'Provider Deleted Succesfully',
                             showConfirmButton:false,
                             timer:1000
                         });
                         this.providers.remove(provider);
                     })
             } else if (
             result.dismiss === Swal.DismissReason.cancel
             ) {
                 Swal({
                     type: 'error',
                     text: 'Cancelled',
                     showConfirmButton:false,
                     timer:1000
                 })
             }
         })


         ejemplo warning con servicio:

         deleteProvider(provider) {
        this.alerta.addAlert('warning','Do you want to Delete provider '+ provider.name+ '?')
      .then((result)=>{
          if(result.value){
              this.ProviderService.removeServiceProvider(provider.pk)
                  .subscribe( result => {
                  }, error => {
                      console.log(error);
                  }, () => {
                     this.alerta.addAlert('success','Provider Deleted Succesfully!!')
                      this.providers.remove(provider);
                  })
          }else if( result.dismiss === Swal.DismissReason.cancel){
           this.alerta.addAlert('error','Cancelled!!')
          }
      })
    }
   */

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/services/alerta.service.ts